import { render, staticRenderFns } from "./Medications.vue?vue&type=template&id=1de5484e&scoped=true"
import script from "./Medications.vue?vue&type=script&lang=js"
export * from "./Medications.vue?vue&type=script&lang=js"
import style0 from "./Medications.vue?vue&type=style&index=0&id=1de5484e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5484e",
  null
  
)

export default component.exports